import type { FieldValues } from 'react-hook-form';
import type { DataManagementProviderProps } from '../../../interfaces/DataManagementProviderProps';
import { DataManagementContext } from '../../../types/DataManagementContext';

export function DataManagementProvider<TData extends FieldValues>({
  children,
  ...props
}: DataManagementProviderProps<TData>) {
  return (
    <DataManagementContext.Provider value={props}>
      {children}
    </DataManagementContext.Provider>
  );
} 